import { render, staticRenderFns } from "./NudgeArticle.vue?vue&type=template&id=1cd69d33&"
import script from "./NudgeArticle.vue?vue&type=script&lang=js&"
export * from "./NudgeArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports